import Mission from "../../views/apps/our_company/Mission.vue";
import Vision from "../../views/apps/our_company/Vision.vue";
import Values from "../../views/apps/our_company/Values.vue";
import HumanResourcesPolicies from "../../views/apps/our_company/HumanResourcesPolicies.vue";
import OurCompanyForms from "@/views/apps/our_company/OurCompanyForms.vue";
import OrganizationalCharts from "@/views/apps/our_company/OurCompanyOrganizationalCharts.vue";
//import DocumentsListOurCompany from "@/views/apps/our_company/documents/DocumentsListOurCompany.vue";
import OurCompanyDocuments from "@/views/apps/our_company/documents/Documents.vue";

import layouts from "../../layout";
/*
import { component } from "vue/types/umd";
import { name } from "vue-echarts-v3";
import layout from "../../layout";
*/

export default {
  path: "/our_company",
  name: "our-company",
  component: () =>
    import(
      /* webpackChunkName: "our-company" */ "../../views/apps/our_company/OurCompany.vue"
    ),
  meta: {
    auth: true,
    title: "Nuestra Compañía",
    tags: ["our_company"]
  },
  redirect: {
    name: "our-company-mission"
  },
  children: [
    // Mision
    {
      path: "",
      name: "our-company-mission",
      component: Mission,
      meta: {
        auth: true,
        searchable: true,
        title: "Mission",
        layout: layouts.navLeft,
        tags: ["our-company", "mission"],
        index: true
      }
    },

    // Vision
    {
      path: "Vision",
      name: "our-company-Vision",
      component: Vision,
      meta: {
        auth: true,
        searchable: true,
        title: "Vision",
        layout: layouts.navLeft,
        tags: ["our-company", "Vision"],
        index: true
      }
    },
    // Valores
    {
      path: "Values",
      name: "our-company-Values",
      component: Values,
      meta: {
        auth: true,
        searchable: true,
        title: "Values",
        layout: layouts.navLeft,
        tags: ["our-company", "Values"],
        index: true
      }
    },
    // Políticas de recursos humanos de la empresa
    {
      path: "HumanResourcesPolicies",
      name: "our-company-policies",
      component: HumanResourcesPolicies,
      meta: {
        auth: true,
        searchable: true,
        title: "Human Resources Policies",
        layout: layouts.navLeft,
        tags: ["our-company", "HumanResourcesPolicies"],
        index: true
      }
    },

    {
      path: "Documents",
      name: "our-company-Documents",
      component: OurCompanyDocuments, // {render: (h) => h("router-view")},
      meta: {
        auth: true,
        searchable: true,
        title: "Documents",
        layout: layouts.navLeft,
        tags: ["our-company", "Documents"],
        index: true
      } /*,
      children: [
        {
          path: "mailshot",
          name: "our-company-mailshot",
          component: DocumentsListOurCompany,
          props: {
            routeFrom: "mailShot"
          },
          meta: {
            auth: true,
            searchable:true,
            title: "Mailshot",
            layout: layouts.navLeft,
            tags: ["our-company", "Mailshot"],
            index: true
          }
        },
        {
          path: "PoliciesandProcesses",
          name: "policies-and-processes",
          component: DocumentsListOurCompany,
          meta: {
            auth: true,
            searchable: true,
            title: "Policies and Processes",
            layout: layouts.navLeft,
            tags: ["our-company", "PoliciesandProcesses"],
            index: true
          }
        },
      ]*/
    },

    {
      path: "OurCompanyForms",
      name: "our-company-forms",
      component: OurCompanyForms,
      meta: {
        auth: true,
        searchable: true,
        title: "Human Resources Forms",
        layout: layouts.navLeft,
        tags: [
          "our-company",
          "HumanResourcesForms",
          "OurCompanyForms",
          "Forms"
        ],
        index: true
      }
    },
    {
      path: "OurCompanyOrganizationalCharts",
      name: "our-company-organizational-charts",
      component: OrganizationalCharts,
      meta: {
        auth: true,
        searchable: true,
        title: "Human Resources Organizational Charts",
        layout: layouts.navLeft,
        tags: [
          "our-company",
          "HumanResourcesForms",
          "OurCompanyOrganizationalCharts",
          "OrganizationalCharts"
        ],
        index: true
      }
    }
  ]
};
